import request from '@/utils/request'
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import JSONBigInt from 'json-bigint'
const JSONBigIntStr = JSONBigInt({ storeAsString: true })
// 系统管理相关接口
// 这个接口可以做缓存
// export const systemType = () =>
//   request({
//     url: '/admin/combo/systemType',
//     method: 'post'
//   })
// 探店字典接口
export const mGetDict = (data: any) =>
  request({
    url: '/pz/dict/getDict',
    method: 'post',
    data
  })
// 用户密码的修改
export const updatePwd = (data: any) =>
request({
  url: '/pz/platformUser/updatePwd',
  method: 'post',
  data
})

export const systemPage = (data: any) =>
  request({
    url: '/admin/system/page',
    method: 'post',
    data
  })
export const systemAdd = (data: any) =>
  request({
    url: '/admin/system/save',
    method: 'post',
    data
  })
export const systemUpdate = (data: any) =>
  request({
    url: '/admin/system/update',
    method: 'post',
    data
  })
export const systemGet = (data: any) =>
  request({
    url: '/admin/system/get',
    method: 'post',
    data
  })
export const systemRemove = (data: any) =>
  request({
    url: '/admin/system/delete',
    method: 'post',
    data
  })
// 配置管理接口
export const configPage = (data: any) =>
  request({
    url: '/admin/config/page',
    method: 'post',
    data
  })
export const configAdd = (data: any) =>
  request({
    url: '/admin/config/save',
    method: 'post',
    data
  })
export const configUpdate = (data: any) =>
  request({
    url: '/admin/config/update',
    method: 'post',
    data
  })
export const configGet = (data: any) =>
  request({
    url: '/admin/config/get',
    method: 'post',
    data
  })
export const configRemove = (data: any) =>
  request({
    url: '/admin/config/delete',
    method: 'post',
    data
  })
// 字典相关接口
export const dictPage = (data: any) =>
  request({
    url: '/dict/page',
    method: 'post',
    data
  })
export const dictRemove = (id: any) =>
  request({
    url: `/dict/delete/${id}`,
    method: 'delete'
  })
export const dictAdd = (data: any) =>
  request({
    url: '/dict/save',
    method: 'post',
    data
  })
export const dictGet = (id: any) =>
  request({
    url: `/dict/get/${id}`,
    method: 'get'
  })
export const dictUpdate = (data: any) =>
  request({
    url: '/dict/update',
    method: 'post',
    data
  })
// 权限管理接口
export const permissionPage = (data: any) =>
  request({
    url: '/admin/permission/page',
    method: 'post',
    data
  })
export const permissionAdd = (data: any) =>
  request({
    url: '/admin/permission/save',
    method: 'post',
    data
  })
export const permissionUpdate = (data: any) =>
  request({
    url: '/admin/permission/update',
    method: 'post',
    data
  })
export const permissionGet = (data: any) =>
  request({
    url: '/admin/permission/get',
    method: 'post',
    data
  })
export const permissionRemove = (data: any) =>
  request({
    url: '/admin/permission/delete',
    method: 'post',
    data
  })
export const permissionTree = (data: any) =>
  request({
    url: '/admin/permission/trees',
    method: 'post',
    data
  })
// 角色管理接口
export const rolePage = (data: any) =>
  request({
    url: '/role/page',
    method: 'post',
    data
  })
export const roleAdd = (data: any) =>
  request({
    url: '/role/save',
    method: 'post',
    data
  })
export const roleUpdate = (data: any) =>
  request({
    url: '/role/update',
    method: 'post',
    data
  })
export const roleGet = (id: any) =>
  request({
    url: `/role/get/${id}`,
    method: 'get'
  })
export const roleRemove = (id: any) =>
  request({
    url: `/role/delete/${id}`,
    method: 'delete'
  })
export const roleUserPage = (data: any) =>
  request({
    url: '/admin/role/authUserPage',
    method: 'post',
    data
  })
export const roleGrant = (data: any) =>
  request({
    url: '/roleRel/userRoleRel',
    method: 'post',
    data
  })
export const roleRevoke = (data: any) =>
  request({
    url: '/roleRel/userRoleRel',
    method: 'delete',
    data
  })
export const rolePermissionTree = (roleId: any) =>
  request({
    url: `/roleRel/getRolePermissionTree/${roleId}`,
    method: 'get'
  })
export const roleMenuRel = (data: any) =>
  request({
    url: '/roleRel/roleMenuRel',
    method: 'post',
    data
  })
// 用户管理接口
export const userAdd = (data: any) =>
  request({
    url: '/sysUser/save',
    method: 'post',
    data
  })
export const userRolePage = (data: any) =>
  request({
    url: '/roleRel/getRoleUserPage',
    method: 'post',
    data
  })
export const userPage = (data: any) =>
  request({
    url: '/sysUser/page',
    method: 'post',
    data
  })
export const userUpdate = (data: any) =>
  request({
    url: '/sysUser/update',
    method: 'post',
    data
  })
export const userGet = (id: any) =>
  request({
    url: `/sysUser/get/${id}`,
    method: 'get'
  })
export const userRemove = (id: any) =>
  request({
    url: `/sysUser/delete/${id}`,
    method: 'delete'
  })
// 机构管理
export const sysOrgTree = (data: any) =>
  request({
    url: '/org/orgTree',
    method: 'post',
    data
  })

export const sysOrgPage = (data: any) =>
  request({
    url: '/org/page',
    method: 'post',
    data
  })
// 机构CRUD
export const sysOrgGet = (id: string) =>
  request({
    url: `/org/get/${id}`,
    method: 'get'
  })

export const sysOrgSave = (data: any) =>
  request({
    url: '/org/save',
    method: 'post',
    data
  })

export const sysOrgUpdate = (data: any) =>
  request({
    url: '/org/update',
    method: 'post',
    data
  })

export const sysOrgRemove = (id: any) =>
  request({
    url: `/org/delete/${id}`,
    method: 'delete'
  })

// export const updatePwd = (data: any) =>
//   request({
//     url: '/sysUser/updatePwd',
//     method: 'post',
//     data
//   })
// 安全管理
export const sysSecurityPage = (query: any) =>
  request({
    url: '/decrypt/page',
    method: 'post',
    data: query,
    transformResponse: [function(res:any) {
      return JSONBigIntStr.parse(res)
    }]
  })
export const sysSecuritySave = (data: any) =>
  request({
    url: '/decrypt/save',
    method: 'post',
    data
  })
export const sysSecurityUpdate = (data: any) =>
  request({
    url: '/decrypt/update',
    method: 'post',
    data,
    transformResponse: [function(res:any) {
      return JSONBigIntStr.parse(res)
    }]
  })
export const sysSecurityGet = (data: any) =>
  request({
    url: '/decrypt/get',
    method: 'post',
    data,
    transformResponse: [function(res:any) {
      return JSONBigIntStr.parse(res)
    }]
  })
export const sysSecurityDelete = (data: any) =>
  request({
    url: '/decrypt/delete',
    method: 'post',
    data
  })
export const sysSecurityGetKey = (data: any) =>
  request({
    url: '/decrypt/generateKey',
    method: 'post',
    data
  })

  // 分页查询-渠道用户
export const speUserPage = (data:any)=>
  request({
    url:'/speUser/page',
    method:'post',
    data
  })
  // 快捷输入待办事项内容列表 /todo/listQuickContent
export const listQuickContent = (data:any)=>
  request({
    url:'/todo/listQuickContent',
    method:'post',
    data
  })

  // 分页查询门店列表
  export const shopCpShopPage = (data:any)=>
  request({
    url:'/shop/cpShopPage',
    method:'post',
    data
  })

  // 批量新增待办事项 /todo/saveBatch
  export const todoSaveBatch = (data:any)=>
  request({
    url:'/todo/saveBatch',
    method:'post',
    data
  })

  // 下载批量导入excel模板
  export const todoDownloadImportTemplate = (data:any)=>
  request({
    url:'/todo/downloadImportTemplate',
    method:'post',
    data,
    responseType: "arraybuffer"
  })

  // 合作伙伴账户列表
  export const partnerAccountPage = (data:any)=>
  request({
    url:'/partner/account/page',
    method:'post',
    data,
  })
  // 合作伙伴账户流水列表
  export const partnerAccountLogPage = (data:any)=>
  request({
    url:'/partner/account/log/page',
    method:'post',
    data,
  })
  // 新增合作账户
  export const partnerAccountSave = (data:any)=>
  request({
    url:'/partner/account/save',
    method:'post',
    data,
  })
// 删除资金账户
export const  PartnerAccountDelete = (id:any)=>
request({
  url: `/partner/account/delete/${id}`,
  method: 'delete'
})
//  更新资金账户信息
export const partnerAccountUpdate = (data:any)=>
request({
  url:'/partner/account/update',
  method:'post',
  data,
})
// 获取资金账户
export const partnerAccount = (id:any)=>
request({
  url:`/partner/account/${id}`,
  method:'get',
})
// 获取充值验证的手机号码
export const partnerGetValidatePhone = (data:any)=>
request({
  url:'/partner/get/validate/phone',
  method:'post',
  data,
  headers:{'Content-Type':'application/x-www-form-urlencoded'},
})
// 发送验证码
export const partnerSendValidateSms = (data:any)=>
request({
  url:'/partner/send/validate/sms',
  method:'post',
  data,
})
// 更新资金账户金额
export const partnerAccountChange = (data:any)=>
request({
  url:'/partner/account/change',
  method:'post',
  data,
})
//企业标签字典
export const GetShopLabelDicts = ()=>
request({
  url:'/shopLabel/getDefaultShopLabel',
  method:'post',

})

// 系统应用 操作日志接口
export const getOperationLog = (data: any)=>
request({
  url:'/log/operation',
  method:'post',
  data
})
// 系统应用 外部日志接口
export const getExternalLog = (data: any)=>
request({
  url:'/log/api',
  method:'post',
  data
})

// 门店日志
export const getShopLog = (data: any)=>
request({
  url:'/log/shop',
  method:'post',
  data
})

// ocr列表接口
export const getOcrLog = (data: any)=>
request({
  url:'/ocr/page',
  method:'post',
  data
})

// 文件列表接口
export const getAliOss = (data: any)=>
request({
  url:'/aliOss/page',
  method:'post',
  data
})

// 文件列表接口
export const getVisitUrl = (data: any)=>
request({
  url:'/aliOss/getVisitUrl',
  method:'post',
  data
})

// 配置前端控制器 start
export const configurePage = (data: any) =>
request({
  url: '/config/page',
  method: 'post',
  data
})

export const configureAdd = (data: any) =>
request({
  url: '/config/save',
  method: 'post',
  data
})

export const configureGet = (id: any) =>
request({
  url: `/config/get/${id}`,
  method: 'get'
})

export const configureUpdate = (data: any) =>
request({
  url: '/config/update',
  method: 'post',
  data
})

export const configureDelete = (id: any) =>
request({
  url: `/config/delete/${id}`,
  method: 'delete'
})
export const queryTaskShopName = (data: any) =>
request({
  url: '/pz/task/queryTaskShopName',
  method: 'post',
  data
})
// 配置前端控制器 end